module.exports = __webpack_public_path__ + "img/33_35.b2a86ef7.png";